import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import SetCard from "components/ui/SetCard";
import TrayModal from "components/ui/TrayModal";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import { useArchivesSets } from "../apis/get-archives-sets";
import { useInView } from "react-intersection-observer";
import { transformArchivesSetData } from "utils/transformdata";
import { useUnarchiveSet } from "../apis/unarchive-set";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { useDeleteSet } from "../apis/deleteSet";
import { useGlobalContext } from "context/GlobalContext";
import SetSkeleton from "components/ui/Skeleton/SetSkeleton";
import { useSettingContext } from "context/SettingContext";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";
import { useFilter } from "context/FilterContext";
import { useLocation } from "react-router-dom";

const SetArchives = () => {
  const [unarchive, setUnarchive] = useState(false);
  const [deleteSetModal, setDeleteSetModal] = useState(false);
  const [viewset, setViewset] = React.useState({ id: "" });
  const [showTrayModal, setShowTrayModal] = React.useState(false);
  const selectedSetArchive = React.useRef(null);
  const toggleDrawer = (data) => {
    setShowTrayModal(true);
    setViewset({
      id: data,
    });
  };

  const { setSortIcon, sortOptions, setSortOptions, sortValue, setSortValue, setSearchPlaceHolder } = useGlobalContext();
  const { search, setSearch, searchBar, setSearchBar } = useSettingContext();
  const { setIsSetFilter, filterValues, setFilterValues, setBackendFilterValues, setFilterCount, setAppliedFilterValues } = useFilter();

  const permission = usePermissions();
  const location = useLocation();

  // const hasAccessToSeeSales = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Sales"), "view");
  // const hasAccessToSeeSales = hasAccessPage(findSpecificPage("Sales Count", permission), "view");

  const hasAccessToYearlySalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By year"), "view");
  const hasAccessToClientSalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By Client"), "view");
  const hasAccessToSeeSales = hasAccessToClientSalesData || hasAccessToYearlySalesData;

  React.useEffect(() => {
    setSortIcon(true);
    if (sessionStorage.getItem("appliedSortValue") > 0) {
      setSortValue(sessionStorage.getItem("appliedSortValue"));
    }
    setSearchPlaceHolder("Search By Set or Design Number");
    setSearchBar(true);
    setSortOptions([
      { id: 1, name: "Set No. (Low to High)", sortBy: "Set Number", order: "asc" },
      { id: 2, name: "Set No. (High to Low)", sortBy: "Set Number", order: "desc" },

      { id: 3, name: "Design Pieces (Low to High)", sortBy: "Number of Styles", order: "asc" },
      { id: 4, name: "Design Pieces (High to Low)", sortBy: "Number of Styles", order: "desc" },

      { id: 5, name: "Set Date (Oldest to Newest)", sortBy: "Set Date", order: "asc" },
      { id: 6, name: "Set Date (Newest to Oldest)", sortBy: "Set Date", order: "desc" },

      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Weight", order: "desc" },

      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: " Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },

      { id: 11, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: hasAccessToSeeSales },
      { id: 12, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: hasAccessToSeeSales },
    ]);
    setIsSetFilter(true);
    setSearchPlaceHolder("Search By Set or Design Number");

    return () => {
      setSortOptions([]);
      setSortValue(null);
      setSortIcon(false);
      sessionStorage.removeItem("appliedSortValue");
      setSearchPlaceHolder("");
      setSearch("");
      setSearchBar(false);
      setIsSetFilter(false);
      setFilterCount(0);
      sessionStorage.setItem("filterChangeCount", 0);
      setAppliedFilterValues({});
      setBackendFilterValues({});
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", sortValue);
  }, [sortValue, sortOptions]);

  const { mutate: unArchiveSet } = useUnarchiveSet({
    onCompleted: () => {
      setUnarchive(false);
    },
  });

  const { mutate: deleteSet } = useDeleteSet({
    onCompleted: () => {
      setDeleteSetModal(false);
    },
  });

  const handleUnarchive = (title) => {
    if (selectedSetArchive.current) {
      const setId = selectedSetArchive.current;
      if (title === "Unarchive") {
        unArchiveSet({ setId });
      } else if (title === "Delete") {
        deleteSet({ setId });
      }
    } else {
      alert("No set ID selected for archiving");
    }
  };

  const modalBtnInfo = React.useMemo(
    () => [
      {
        btnName: "Unarchive",
        bgColor: "#E77B7B",
        click: () => handleUnarchive("Unarchive"),
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setUnarchive(false),
      },
    ],
    []
  );

  const deleteModalBtnInfo = React.useMemo(
    () => [
      {
        btnName: "Delete",
        bgColor: "#E77B7B",
        click: () => handleUnarchive("Delete"),
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setDeleteSetModal(false),
      },
    ],
    []
  );

  const unArchivesbuttons = [
    {
      btnId: 1,
      title: "Delete",
      view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "delete"),
    },
    {
      btnId: 2,
      title: "Unarchive",
      view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "unarchive"),
    },
  ];

  const selectedOption = sortOptions.find((option) => option?.id == sortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  const diamondPieces = filterValues && filterValues["Diamond Pieces"];
  const diamondWeight = filterValues && filterValues["Diamond Weight"];
  const goldGrossWeight = filterValues && filterValues["Gold Gross-Weight"];
  const goldNetWeight = filterValues && filterValues["Gold Net-Weight"];
  const designQuantity = filterValues && filterValues?.piecesCount?.length > 0 ? filterValues?.piecesCount[0] : "";
  const collectionName = filterValues && filterValues?.collectionName?.length > 0 ? filterValues?.collectionName[0] : "";
  const categoriesName = filterValues && filterValues?.categoriesName;
  const isHidden = filterValues && filterValues["Show Hidden Designs"];

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useArchivesSets({
    limit: 12,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    searchTerm: search,
    diamondPieces,
    diamondWeight,
    goldGrossWeight,
    goldNetWeight,
    designQuantity,
    collectionName,
    categoriesName,
    isHidden:!isHidden,
    allowRefetch: filterValues && Object.keys(filterValues).length > 0,
  });

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 1.0,
  });

  const {
    data: sliderData,
    isLoading: isSliderDataLoading,
    isError: isSliderDataError,
  } = useQuery({
    queryKey: ["sliderData", "archive"],
    queryFn: async () => {
      const response = await apiClient.get(`/api/v1/set/getSetDesignSlidersData?isArchive=true`);
      return response?.data?.data;
    },
    refetchOnMount: true,
  });

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        if (sliderData) {
          const { diamondPieces, diamondWeight, grossWeight, netWeight, designQuantity, collectionName, categoryName } = sliderData;
          let filterData = {
            "Diamond Pieces": diamondPieces || [],
            "Diamond Weight": diamondWeight || [],
            "Gold Net-Weight": netWeight || [],
            Pieces: designQuantity || [],
            Collections: collectionName || [],
            Categories: categoryName || [],
            collectionName: [],
            piecesCount: [],
            categoriesName: [],
            "Show Hidden Designs":false
          };
          setBackendFilterValues(filterData);
          setFilterValues(filterData);

          setFilterValues((prev) => {
            const mergedFilters = { ...filterData };
            for (const key in prev) {
              if (Array.isArray(prev[key]) && prev[key].length > 0) {
                mergedFilters[key] = prev[key];
              }
            }

            return mergedFilters;
          });
          const filterChangeCount = JSON.parse(sessionStorage.getItem("filterChangeCount"));
          if (filterChangeCount === 0) {
            setFilterValues(filterData);
          } else {
            setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    // if (isEdit === "archive" || innerChnages) {
    fetchFilterData();
    // }
  }, [sliderData, location]);

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  if (isLoading) return <SetSkeleton count={12} button={true} />;
  if (isError) return <div>Error: {error.message}</div>;

  return (
    <Box
    // sx={{
    //   maxHeight: "78vh",
    //   // border: "5px solid red",
    //   overflowY: "scroll",
    //   "&::-webkit-scrollbar": {
    //     width: "0px",
    //   },
    //   "&::-webkit-scrollbar-thumb": {
    //     background: "transparent",
    //   },
    // }}
    >
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "30px",
          rowGap: "32px",
          mb: "0px",
        }}
      >
        {data?.pages?.map((page) =>
          page?.sets?.map((set, _ind) => (
            <Grid item className="product" key={set._id}>
              <SetCard
                data={transformArchivesSetData(set)}
                isBtn={"click"}
                openDrawer={() => toggleDrawer(set._id)}
                // btnTitle={"Unarchive"}
                btnInfo={unArchivesbuttons}
                buttonClick={(title) => {
                  selectedSetArchive.current = set._id;
                  if (title === "Delete") {
                    setDeleteSetModal(true);
                  } else {
                    setUnarchive(true);
                  }
                }}
              />
            </Grid>
          ))
        )}
        <div ref={ref} style={{ height: "10px", marginTop: "10px" }} />
      </Grid>

      {isFetchingNextPage && (
        <div style={{}}>
          <SetSkeleton count={3} button={true} />
        </div>
      )}

      <RemoveModal open={unarchive} setOpen={setUnarchive} btnInfo={modalBtnInfo} heading="Do you want to Unarchive this Set?" />
      <RemoveModal open={deleteSetModal} setOpen={setDeleteSetModal} btnInfo={deleteModalBtnInfo} heading="Do you want to Delete this Set?" />
      <TrayModal cardId={viewset} open={showTrayModal} setOpen={setShowTrayModal} trayName={viewset.name} isView={true} topOffset={150}/>

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.sets?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "78vh",
            }}
          >
            <Background />
          </div>
        ))}
    </Box>
  );
};

export default SetArchives;
